// @angular/core
import {
	Component,
	EventEmitter,
	ChangeDetectionStrategy,
	Output,
	OnDestroy,
	OnInit,
	ChangeDetectorRef,
	ContentChildren,
	QueryList,
	AfterViewInit
} from '@angular/core'

// rxjs
import { Subscription } from 'rxjs';

// rxjs/operators
import { filter } from 'rxjs/operators';

// Components
import { FangTabComponent } from './fang-tab.component';

@Component({
	selector: 'fang-multi-tabs',
	templateUrl: './fang-multi-tabs.component.html',
	styleUrls: ['./fang-multi-tabs.component.scss'],
	changeDetection: ChangeDetectionStrategy.Default
})

export class FangMultiTabsComponent implements OnInit, AfterViewInit, OnDestroy {

    @ContentChildren(FangTabComponent)
	public tabs: QueryList<FangTabComponent>;

    @Output()
	public selectedTabChanged = new EventEmitter<void>();

    private _changesSubscription$: Subscription;

	constructor(
		private _changeDetectorRef: ChangeDetectorRef
	) {}

	// @Override
    ngOnInit(): void {
		console.log('FangMultiTabsComponent [ngOnInit]');
    }

	// @Override
	ngAfterViewInit(): void {
		// Set initial active tab
		if  (this.tabs.length && !this.tabs.first.active ) {
			this.selectTab(this.tabs.first);
		}

		// Set selected Tab after each time child view changes on a single lifecycle
		this._changesSubscription$ = this.tabs.changes
			.pipe(
				filter((change) => change.first)
			)
			.subscribe(() => this.selectTab(this.tabs.first))
	}

	// @Override
	ngOnDestroy(): void {
		this._changesSubscription$.unsubscribe();
	}

    public selectTab(tab: FangTabComponent) {
		console.log('FangMultiTabsComponent [selectTab]');

        this.tabs.toArray().map(tab => tab.active = false);

        tab.active = true;

        this.selectedTabChanged.emit();

		this._changeDetectorRef.detectChanges();
    }
}






